export default {"src":"/_next/static/media/desktop.0aeed328.svg","height":44,"width":62,"blurWidth":0,"blurHeight":0};